module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Marca")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    staticClass: "form-control w-auto w-full-xs",
    attrs: {
      "disabled": _vm.id === null
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.model = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.change]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.id !== null ? (_vm.isLoading ? 'Carregando' : 'Selecione') : 'Selecione o tipo de bem primeiro'))]), _vm._v(" "), _vm._l((_vm.marcas), function(marca) {
    return _c('option', {
      key: marca.id,
      domProps: {
        "value": marca.id
      }
    }, [_vm._v(_vm._s(marca.nome))])
  })], 2), _vm._v(" "), (_vm.loadError) ? _c('a', {
    staticClass: "btn text-danger",
    on: {
      "click": _vm.load
    }
  }, [_vm._v("Não foi possível carregar. Tente novamente")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e802e2be","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/SelectMarca.vue
// module id = 1902
// module chunks = 17